// QR Kiosk v2 — StatusPip (status dot) + CountPill (mono count pill).
// Ported from designer kiosk-shared.jsx (StatusDot + CountPill). Tokens only.
import React from "react";

export type PipTone = "--red" | "--amber" | "--green" | "--tier-accent";

export interface StatusPipProps {
  tone?: PipTone;
  size?: number;
}

export function StatusPip({ tone = "--red", size = 10 }: StatusPipProps) {
  return (
    <span
      style={{
        width: size,
        height: size,
        borderRadius: 999,
        background: `var(${tone})`,
        display: "inline-block",
        flexShrink: 0,
      }}
    />
  );
}

export interface CountPillProps {
  n: number;
  tone?: PipTone;
}

export function CountPill({ n, tone = "--amber" }: CountPillProps) {
  return (
    <span
      style={{
        fontFamily: "var(--font-mono)",
        fontSize: 11,
        fontWeight: 700,
        minWidth: 22,
        height: 22,
        padding: "0 7px",
        borderRadius: 999,
        display: "inline-grid",
        placeItems: "center",
        background: `color-mix(in oklab, var(${tone}) 14%, var(--card))`,
        border: `1px solid color-mix(in oklab, var(${tone}) 38%, var(--border))`,
        color: `color-mix(in oklab, var(${tone}) 82%, var(--ink))`,
      }}
    >
      {n}
    </span>
  );
}
